import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

// Stub — renders children unconditionally so the AppShell tree mounts in
// isolation (libs/shared tests, Storybook). The host overrides with a real
// OIDC provider that dispatches processAuthToken on the callback.

type AuthContextValue = {
  isAuthenticated: boolean;
  isLoading: boolean;
};

const AuthContext = createContext<AuthContextValue>({
  isAuthenticated: false,
  isLoading: false,
});

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}

type Props = { children: ReactNode };

export function AuthProvider({ children }: Props) {
  return (
    <AuthContext.Provider value={{ isAuthenticated: false, isLoading: false }}>
      {children}
    </AuthContext.Provider>
  );
}
